import { render, staticRenderFns } from "./SchoolIcon.vue?vue&type=template&id=5e7486f7&"
import script from "./SchoolIcon.vue?vue&type=script&lang=js&"
export * from "./SchoolIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports